import {
	SET_GLOBAL_SEARCH,
	SET_TOTAL_COUNT_ALL_AREAS,
	SET_SEARCH_PARAMETERS,
	SET_AREA_SEARCH,
	SET_AREA_SEARCH_PARAMETERS,
	CLEAR_ALL_AREA_SEARCHES,
	CLEAR_ALL_AREA_SEARCH_PARAMETERS,
	SET_AREA_SEARCH_PAGE,
	SET_CURRENT_MODAL,
	SET_ACTIVITY_POPOVER,
	CLEAR_AREA_SEARCH_PAGE
} from './global-search-mutation-types';
import globalSearchCategories from './global-search-categories';
import api from '@/services/api-service';
import buildRoute from '@/composables/build-route';
import parameterizeArray from '@/utils/parameterize-array';
import Vue from 'vue';
import { formatInt } from '@/utils/number-format-functions';

const categoriesApiFormat =
	'/globalsearch/company/{companyId}/categories?searchText={search}&maxCount={maxCount}&companyId={companyId}&page={page}&includeInactive={includeInactive}';

const categoryApiFormat =
	'/globalsearch/company/{companyId}/category/{area}?searchText={search}&maxCount={maxCount}&area={area}&companyId={companyId}&page={page}&includeInactive={includeInactive}&SortBy={sortBy}&SortDirection={sortDirection}';

export default {
	strict: process.env.NODE_ENV !== 'production',
	name: 'globalSearch',
	namespaced: true,
	state: {
		globalSearchResults: undefined,
		totalCountAllAreas: 0,
		searchParameters: {},
		areaGlobalSearchResults: undefined,
		areaGlobalSearchPageResults: undefined,
		areaGlobalSearchParameters: undefined,
		currentModal: undefined,
		customerActivityResults: undefined
	},
	mutations: {
		[SET_GLOBAL_SEARCH](state, globalSearch) {
			state.globalSearchResults = globalSearch;
		},
		[SET_TOTAL_COUNT_ALL_AREAS](state, globalSearch) {
			let count = 0;
			let area;

			if (globalSearch) {
				for (const prop in globalSearch) {
					area = globalSearch[prop];

					if (area) {
						count += area.totalCount;
					}
				}
			}

			state.totalCountAllAreas = count;
		},
		[SET_SEARCH_PARAMETERS](state, searchParameters) {
			state.searchParameters = searchParameters;
		},
		[CLEAR_AREA_SEARCH_PAGE](state) {
			state.areaGlobalSearchPageResults = undefined;
		},
		[SET_AREA_SEARCH_PAGE](
			state,
			{ area, page, inactive, areaGlobalSearch, resetPages }
		) {
			if (state.areaGlobalSearchPageResults == undefined) {
				state.areaGlobalSearchPageResults = {};
			}

			if (state.areaGlobalSearchPageResults[area] == undefined) {
				state.areaGlobalSearchPageResults[area] = {};
			}

			if (state.areaGlobalSearchPageResults[area][page] == undefined) {
				state.areaGlobalSearchPageResults[area][page] = {};
			}

			if (resetPages) {
				let areaObj = {};

				areaObj[page] = {};
				areaObj[page][inactive] = areaGlobalSearch;

				Vue.delete(state.areaGlobalSearchPageResults, area);
				Vue.set(state.areaGlobalSearchPageResults, area, areaObj);
			} else {
				Vue.set(
					state.areaGlobalSearchPageResults[area][page],
					inactive,
					areaGlobalSearch
				);
			}
		},
		[SET_AREA_SEARCH_PARAMETERS](state, areaSearchParameters) {
			if (state.areaGlobalSearchParameters == undefined) {
				state.areaGlobalSearchParameters = {};
			}

			state.areaGlobalSearchParameters[
				areaSearchParameters.area
			] = areaSearchParameters;
		},
		[CLEAR_ALL_AREA_SEARCH_PARAMETERS](state) {
			state.areaGlobalSearchResults = undefined;
		},
		[CLEAR_ALL_AREA_SEARCHES](state) {
			state.areaGlobalSearchParameters = undefined;
		},
		[SET_AREA_SEARCH](state, { area, areaGlobalSearch }) {
			if (state.areaGlobalSearchResults == undefined) {
				const areaGlobalSearchResults = {};
				areaGlobalSearchResults[area] = areaGlobalSearch;
				state.areaGlobalSearchResults = areaGlobalSearchResults;
			} else {
				Vue.set(state.areaGlobalSearchResults, area, areaGlobalSearch);
			}
		},
		[SET_CURRENT_MODAL](state, currentModalArea) {
			state.currentModal = currentModalArea;
		},
		[SET_ACTIVITY_POPOVER](state, customerActivitySearch) {
			state.customerActivityResults = customerActivitySearch;
		}
	},
	actions: {
		// actions let us get to ({ state, getters, commit, dispatch }) {
		async getGlobalSearchAction({ commit }, parameters) {
			const route = buildRoute(categoriesApiFormat, parameters);
			const category = globalSearchCategories.find(
				cat => cat.value === parameters.area
			);
			let categoryQueryParamString;

			if (category && category.categories) {
				categoryQueryParamString = parameterizeArray(
					'Category',
					category.categories
				);
			} else {
				categoryQueryParamString = `Category=${parameters.area}`;
			}

			const globalSearch = await api.get(
				route + '&' + categoryQueryParamString
			);

			commit(SET_GLOBAL_SEARCH, globalSearch);
			commit(SET_TOTAL_COUNT_ALL_AREAS, globalSearch);
			commit(SET_SEARCH_PARAMETERS, parameters);

			//clear area searches
			commit(CLEAR_ALL_AREA_SEARCH_PARAMETERS);
			commit(CLEAR_ALL_AREA_SEARCHES);

			//set page data so we don't have to requery results when paging
			if (globalSearch !== undefined) {
				for (const prop in globalSearch) {
					if (globalSearch[prop]) {
						commit(SET_AREA_SEARCH_PAGE, {
							area: globalSearch[prop].area,
							page: globalSearch[prop].page,
							inactive: parameters.includeInactive,
							areaGlobalSearch: globalSearch[prop],
							resetPages: true
						});
					}
				}
			}
		},
		async getAreaGlobalSearchPageAction(
			{ commit, state, getters },
			{ area, page, inactive, sortBy, sortDirection }
		) {
			const searchParameters = { ...state.searchParameters };
			let resetPages = false;
			let currentSortBy = '';
			let currentSortDirection = '';
			let areaGlobalSearchPageResults;

			searchParameters.includeInactive = inactive;
			searchParameters.area = area;

			if (
				getters.areaGlobalSearchParameters(area) &&
				getters.areaGlobalSearchParameters(area).sortBy &&
				getters.areaGlobalSearchParameters(area).sortDirection
			) {
				currentSortBy = getters.areaGlobalSearchParameters(area).sortBy;
				currentSortDirection = getters.areaGlobalSearchParameters(area)
					.sortDirection;
			}

			//see if we already have the page
			if (
				currentSortBy === sortBy &&
				currentSortDirection === sortDirection
			) {
				areaGlobalSearchPageResults = getters.areaGlobalSearchPageResults(
					area,
					page,
					inactive
				);
			} else {
				resetPages = true;
			}

			searchParameters.sortDirection = sortDirection || '';
			searchParameters.sortBy = sortBy || '';

			//if not, make the api call
			if (!areaGlobalSearchPageResults) {
				searchParameters.area = area;
				searchParameters.page = page;

				areaGlobalSearchPageResults = await api.get(
					buildRoute(categoryApiFormat, searchParameters)
				);
				areaGlobalSearchPageResults.includeInactive = inactive;
				commit(SET_AREA_SEARCH_PAGE, {
					area: area,
					page: page,
					inactive: inactive,
					areaGlobalSearch: areaGlobalSearchPageResults,
					resetPages: resetPages
				});
			}
			commit(SET_AREA_SEARCH_PARAMETERS, searchParameters);
		},
		async getAreaGlobalSearchAction({ commit }, parameters) {
			const searchParameters = {
				area: parameters.area,
				search: parameters.search,
				companyId: parameters.companyId,
				page: 1,
				includeInactive:
					parameters.area == 'C' ? parameters.includeInactive : false,
				maxCount: 250
			};

			const areaGlobalSearchResults = await api.get(
				buildRoute(categoryApiFormat, searchParameters)
			);

			commit(SET_AREA_SEARCH, {
				area: parameters.area,
				areaGlobalSearch: areaGlobalSearchResults
			});
			commit(SET_AREA_SEARCH_PARAMETERS, searchParameters);
		},
		async getCustomerActivityResults(
			{ commit },
			{ companyId, customerId, numberOfActivities }
		) {
			const parameters = {
				companyId: companyId,
				customerid: customerId,
				numberOfActivities: numberOfActivities
			};
			const customerActivityResults = await api.get(
				buildRoute(
					'/customers/company/{companyId}/mostrecentactivity?customerId={customerid}&numberOfActivities={numberOfActivities}',
					parameters
				)
			);
			commit(SET_ACTIVITY_POPOVER, customerActivityResults);
		},
		setSearchParametersAction({ commit }, searchParameters) {
			commit(SET_SEARCH_PARAMETERS, searchParameters);
		},
		setCurrentModalAction({ commit }, currentModalArea) {
			commit(SET_CURRENT_MODAL, currentModalArea);
		}
	},
	getters: {
		globalSearchResults: state => state.globalSearchResults,
		totalCountAllAreas: state => {
			let stringCount = '';

			if (state.totalCountAllAreas) {
				stringCount = formatInt(state.totalCountAllAreas);
			}

			return stringCount;
		},
		totalCountArea: state => area => {
			let count;
			if (
				state.areaGlobalSearchResults != undefined &&
				state.areaGlobalSearchResults[area] != undefined
			) {
				count = formatInt(
					state.areaGlobalSearchResults[area].totalCount
				);
			}
			return count;
		},
		searchParameters: state => {
			return state.searchParameters;
		},
		areaGlobalSearchResults: state => area => {
			let returnData;

			if (
				state.areaGlobalSearchResults != undefined &&
				state.areaGlobalSearchResults[area] != undefined
			) {
				returnData = state.areaGlobalSearchResults[area];
			}

			return returnData;
		},
		areaGlobalSearchPageResults: state => (area, page, inactive) => {
			let returnData;

			if (
				state.areaGlobalSearchPageResults &&
				state.areaGlobalSearchPageResults[area] &&
				state.areaGlobalSearchPageResults[area][page] &&
				state.areaGlobalSearchPageResults[area][page][inactive]
			) {
				returnData =
					state.areaGlobalSearchPageResults[area][page][inactive];
			}

			return returnData;
		},
		areaGlobalSearchAllItems: state => (area, inactive) => {
			const items = [];
			let pageObject;

			if (
				state.areaGlobalSearchPageResults &&
				state.areaGlobalSearchPageResults[area]
			) {
				pageObject = state.areaGlobalSearchPageResults[area];

				for (const prop in pageObject) {
					if (Object.hasOwnProperty.call(pageObject, prop)) {
						if (
							pageObject[prop] &&
							pageObject[prop][inactive] &&
							pageObject[prop][inactive].items &&
							pageObject[prop][inactive].items.length > 0
						)
							items.push(...pageObject[prop][inactive].items);
					}
				}
			}

			return items;
		},
		areaGlobalSearchParameters: state => area => {
			let returnParameters;
			if (
				state.areaGlobalSearchParameters &&
				state.areaGlobalSearchParameters[area]
			)
				returnParameters = state.areaGlobalSearchParameters[area];
			return returnParameters;
		},
		currentModal: state => state.currentModal,
		customerActivityResults: state => state.customerActivityResults
	}
};
